import { render } from "./orthopedic_history.vue?vue&type=template&id=651faaee&scoped=true"
import script from "./orthopedic_history.vue?vue&type=script&lang=js"
export * from "./orthopedic_history.vue?vue&type=script&lang=js"

import "./orthopedic_history.vue?vue&type=style&index=0&id=651faaee&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651faaee"]])

export default __exports__